'use client'

import { useEffect, useRef } from 'react'

import removeTargetAttributeForHashAnchorTags from '@src/quince-site-common/src/utils/removeTargetAttributeForHashAnchorTags'
import { ProductDetailsIconSectionDS } from '@src/quince-site-pdp/src/atoms/productDetailsIcon/product-details-icon-section-ds'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { convertRelativeToAbsoluteUrls } from '@src/utils/general.utils'

import { contentBaseClass, iconsWrapperClass, wrapperBaseClass } from './product-description-ds.styles'
import { getProductDescription } from './utils'

import type { ProductDescriptionProps } from './product-description.types'

export const ProductDescriptionDS = ({
  description,
  showNewPdpDesignV2,
  productDetailsIcons,
  showReadMoreInDesc: _showReadMoreInDesc,
  isB2BMode,
}: ProductDescriptionProps) => {
  const showReadMore = false
  const productFormContentRef = useRef<HTMLDivElement>(null)
  const productDescription = isB2BMode ? convertRelativeToAbsoluteUrls(description) : description

  useEffect(() => {
    removeTargetAttributeForHashAnchorTags(productFormContentRef.current)
  }, [])

  useEffect(() => {
    if (!productFormContentRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            trackEvent(TELEMETRY_EVENT_NAMES.PRODUCT_SUMMARY_IS_VISIBLE, {
              // eslint-disable-next-line i18next/no-literal-string
              entity_type: 'action',
              entity_id: 'product_summary',
            })
            observer.disconnect()
          }
        })
      },
      { threshold: 0.2 },
    )

    observer.observe(productFormContentRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div className={wrapperBaseClass}>
      <div
        className={contentBaseClass}
        ref={productFormContentRef}
        //eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getProductDescription(productDescription, showReadMore, true),
        }}
      />
      {showNewPdpDesignV2 && (
        <ProductDetailsIconSectionDS icons={productDetailsIcons} wrapperClassName={iconsWrapperClass} />
      )}
    </div>
  )
}
